
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.023.719l4.063 9.838 10.711.783c.484.035.876.34 1.026.796s.014.931-.357 1.241l-8.2 6.864 2.556 10.322c.115.466-.056.929-.448 1.212s-.891.3-1.303.047l-9.13-5.596-9.13 5.596c-.412.253-.911.235-1.303-.047s-.563-.746-.448-1.211l2.557-10.322-8.2-6.864c-.37-.31-.506-.784-.356-1.241s.542-.761 1.025-.796l10.711-.783L15.86.72c.183-.444.597-.719 1.082-.719s.899.275 1.082.719z"}})])
          )
        }
      }
    